import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import PicList from '../../../../components/picList';
import NewsList from '../../../../components/newsList';

class BookBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { bookTopic, bookTitle, bookList0, bookList1 },
        } = this.props;

        return (
            <div id="bookNewsList" className={styles.book_box}>
                <Chip id="50075" type="struct" title="文化读书栏标题" groupName="文化读书栏" content={bookTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75090"
                    type="recommend"
                    title="文化读书栏头条"
                    groupName="文化读书栏"
                    content={bookTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75091"
                    type="recommend"
                    title="文化读书栏新闻列表1"
                    groupName="文化读书栏"
                    content={bookList0}
                    translate="handleVideoContentData"
                    translateOptions={{ index: 0 }}>
                    <PicList />
                </Chip>
                <Chip
                    id="75092"
                    type="recommend"
                    title="文化读书栏新闻列表2"
                    groupName="文化读书栏"
                    content={bookList1}
                    translate="handleNewsContentData">
                    <NewsList hasTitle isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(BookBox);
